import { MESSAGE_TYPES, SESSION_TYPES } from '@/enums'
import { v4 as uuidv4 } from 'uuid'

const initialState = () => ({
  message: null,
  firstMessageSid: null,
  queueIsConnected: false,
  previousSession: null, // BOT || CHAT
})
export const state = initialState()

export const mutations = {
  UPDATE_MESSAGE(state, payload) {
    if (!state.message) {
      state.message = {
        body: payload,
        timestamp: new Date(),
        sid: uuidv4(),
        attributes: {
          type: MESSAGE_TYPES.SYSTEM,
          incoming: false,
        },
      }
    } else if (state.message.body !== payload) {
      state.message.body = payload
      state.message.timestamp = new Date()
    }
  },
  SAVE_FIRST_MESSAGE_SID(state, payload) {
    state.firstMessageSid = payload
  },
  CLEAR_MESSAGE(state) {
    state.message = null
    state.firstMessageSid = null
    state.queueIsConnected = false
  },
  SET_QUEUE_IS_CONNECTED(state) {
    state.queueIsConnected = true
  },
  UPDATE_PREVIOUS_SESSION(state, payload) {
    state.previousSession = payload
  },
  RESET(state) {
    const newState = initialState()
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key]
    })
  },
}

export const actions = {
  saveFirstClientMessage({ commit, dispatch }, payload) {
    const message = {
      body: payload,
      timestamp: new Date(),
      sid: uuidv4(),
      type: MESSAGE_TYPES.TEXT,
      attributes: {
        type: MESSAGE_TYPES.LIVE_CHAT,
        incoming: true,
      },
    }
    commit('SAVE_FIRST_MESSAGE_SID', message.sid)
    // state property is require until Twilio upgrade
    dispatch('LiveChat/updatesChatMessages', message, { root: true })
  },
  transfertSessionToQueue({ commit, dispatch, rootState }) {
    commit('UPDATE_PREVIOUS_SESSION', rootState.Widget.sessionType)
    dispatch('Widget/updateSessionType', SESSION_TYPES.QUEUING, {
      root: true,
    })
  },
  returnToLastSession({ state, commit, dispatch, rootState }) {
    if (rootState.Widget.sessionType === SESSION_TYPES.QUEUING) {
      dispatch('Widget/updateSessionType', state.previousSession, {
        root: true,
      })
    }
    commit('UPDATE_PREVIOUS_SESSION')
    commit('RESET')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
